import { render } from "./course-details.vue?vue&type=template&id=b818457e&scoped=true"
import script from "./course-details.vue?vue&type=script&lang=js"
export * from "./course-details.vue?vue&type=script&lang=js"

import "./course-details.vue?vue&type=style&index=0&id=b818457e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b818457e"]])

export default __exports__